<template>
  <div class="home-seo" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class='container'>
      <div class="home-seo-content">
        <div class='row'>
          <div class='col-xs-12'>
            <h1><strong>Welcome to Hometown Auto Dealer</strong></h1>
            <p>Hometown Auto Dealer is the go-to <span>{{brandName}}</span> dealership serving Raleigh, Apex, Cary, Holly Springs, Morrisville and the Research Triangle Park. We offer a variety of New Cars, Used Cars, and <span>{{brandName}}</span> Certified Used Cars. When dealing with Hometown Auto Dealer, expect to find the perfect <span>{{brandName}}</span> that fits your needs and wants. Check out our <a href="#">reviews</a> to see what our customers are saying.</p>
            <p>Our team is made up of certified <span>{{brandName}}</span> Experts, factory-trained service technicians and <span>{{brandName}}</span> financing experts who will assist you in finding the best vehicle at the right price. Our customers are like family to us, so we will be sure to treat you right. Come on by our dealership located at 123 Main Street, Raleigh, NC 27615.</p>
            <div class="collapse" id="home-seo-collapse-content">
              <h2><strong>New <span>{{brandName}}</span> Cars in Raleigh, NC</strong></h2>
              <p>Car buying should be simple and here at Hometown Auto Dealer we do just that. View our new vehicles to see what we have to offer. Whether it's a <a href="#"><span>{{brandName}}</span> {{ images.sedans[0].modelName }}</a>, <a href="#"><span>{{brandName}}</span> {{ images.suvs[0].modelName }}</a>, <a href="#"><span>{{brandName}}</span> {{ images.suvs[1].modelName }}</a>, or <a href="#"><span>{{brandName}}</span> {{ images.suvs[2].modelName }}</a>, we continuously update our new vehicle lineup to offer the latest and greatest of <span>{{brandName}}</span> vehicles. Stop by our dealership to test drive any of our new vehicles so you can experience the <span>{{brandName}}</span> ride. By serving Raleigh, Apex, Cary, Holly Springs, Morrisville and the Research Triangle Park, there is no need to explore far because we have everything here. Check out our new vehicle specials to view some of our latest deals.</p>
              <h2><strong>Used Cars & Certified Pre-owned <span>{{brandName}}</span> Cars in Raleigh, NC</strong></h2>
              <p>Finding a quality used car can be difficult. Here at Hometown Auto Dealer, our <span>{{brandName}}</span> experts can assist you in finding the car you want in great condition. Search our <a href="#">Used Car inventory</a> online or our <a href="#"><span>{{brandName}}</span> Certified Used Vehicle</a> inventory if you are looking for a <span>{{brandName}}</span> graded used car. Visiting our <a href="#">Vehicles under 15K</a> may be your best option if looking to save money. We even offer <a href="#">Used Vehicle Specials</a>! You can find plenty of quality used cars on our website and on our lot here at Hometown Auto Dealer.</p>
              <h2><strong>Get <span>{{brandName}}</span> Auto Financing and Auto Lease Deals</strong></h2>
              <p>Hometown Auto Dealer is offering our best financing deals and Auto leases. We assure you that our <span>{{brandName}}</span> Financing Experts will have you set up with a vehicle that matches your price range. Our <span>{{brandName}}</span> dealership allows you to use our payment tools easily online for our <span>{{brandName}}</span> cars. Easily access them on our <a href="#">Finance page</a>. We offer a convenient way to Get Pre-Approved with our two-step online process.</p>
              <h2><strong>Get Affordable and Reliable <span>{{brandName}}</span> Auto Service & <span>{{brandName}}</span> Parts</strong>
              </h2>
              <p>Having limited time and money can restrict us from keeping up with our vehicle maintenance. At Hometown Auto Dealer, we offer plenty of <a href="#">Service and Parts Specials</a> to help you save on your visit. If you are looking to get an oil change, tire change or looking for parts and other accessories, our factory-trained service technicians will get you in and out in no time. Don't forget to schedule a <a href="#">Service Appointment online</a> or call us at (555) 123-4567.</p>
            </div>
            <a class="more-link" role="button" data-toggle="collapse" href="#home-seo-collapse-content" aria-expanded="false" aria-controls="home-seo-collapse-content">Read More &nbsp; <i class="fa fa-chevron-down" aria-hidden="true"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand
      }
    },
    computed: {
      brandName () {
        if (this.brand === 'none') {
          return 'Brand';
        } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
          return this.brand.toUpperCase();
        } else {
          return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
        }
      }
    },
    mounted() {
      $('#home-seo-collapse-content').on('show.bs.collapse', function () {
        $( ".home-seo .more-link" ).html('Read Less <i class="fa fa-chevron-up" aria-hidden="true">');
      });
      $('#home-seo-collapse-content').on('hide.bs.collapse', function () {
        $( ".home-seo .more-link" ).html('Read More <i class="fa fa-chevron-down" aria-hidden="true">');
      });
    }
  };
  </script>
  
  <style
    scoped
    src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
  ></style>

  <style scoped>
    .home-seo {
      background-color: #fff;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .home-seo h1, .home-seo h2 {
      font-size: 16px;
    }
    .home-seo p {
      font-weight: 400;
      line-height: 29px;
    }
    .home-seo-content {
      background-color: #f5f5f5;
      color: var(--primary-dark);
      font-size: 15px;
      padding: 30px;
    }
    .home-seo a {
      text-decoration: none;
      color: var(--primary-color);
      font-weight: 500;
    }
    .home-seo[data-brand="cjdr"] a {
      color: var(--secondary-color);
    }
    .home-seo a:hover {
      text-decoration: none;
      opacity: .7;
    }
    .home-seo .more-link:hover, .home-seo .more-link:focus {
      cursor: pointer;
      color: var(--primary-color);
    }
    .home-seo[data-brand="cjdr"] .more-link:hover, 
    .home-seo[data-brand="cjdr"] .more-link:focus {
      cursor: pointer;
      color: var(--secondary-color);
    }
  </style>